import React from 'react';

import { CompanionsBanner } from '../matter/CompanionsBanner';
import { MatterTitle } from '../matter-title';

interface MatterTopNavProps {
  /** UUID of the currently selected matter */
  matterId?: string;
}

const MatterTopNav: React.FC<MatterTopNavProps> = ({ matterId }) => {
  return (
    <div className="border-b border-zinc-100">
      <div className="flex items-center justify-between px-4 py-0">
        <MatterTitle />
      </div>

      <CompanionsBanner matterId={matterId} />
    </div>
  );
};

export default MatterTopNav;
